import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Lessons from '../components/Lessons';
import Teacher from '../components/Teacher';
import BookSection from '../components/BookSection';
import Reviews from '../components/Reviews';
import FAQ from '../components/FAQ';
import Blog from '../components/Blog';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const HomePage = ({ onOpenBooking, onOpenLogin }) => (
  <>
    <Header onLogin={onOpenLogin} onCtaBook={onOpenBooking} />
    <main>
      <Hero onBook={onOpenBooking} />
      <Lessons onBook={onOpenBooking} />
      <Teacher />
      <BookSection />
      <Reviews />
      <Blog />
      <FAQ />
      <Contact onOpenBooking={onOpenBooking} />
    </main>
    <Footer />
  </>
);

export default HomePage;
